/** 标题至少需要这么多像素，否则把「历史会话 / 当前会话」收成图标 */
export const AI_HEADER_TITLE_MIN_PX = 120;
export const AI_HEADER_GAP_PX = 8;
export const AI_HEADER_CLUSTER_GAP_PX = 6;

export function shouldCompactAiHeaderActions(args: {
  headerWidth: number;
  leadingWidth: number;
  expandedTabsWidth: number;
  roundActionsWidth: number;
  minTitleWidth?: number;
}): boolean {
  const minTitle = args.minTitleWidth ?? AI_HEADER_TITLE_MIN_PX;
  const leading = Math.max(0, args.leadingWidth);
  const tabs = Math.max(0, args.expandedTabsWidth);
  const actions = Math.max(0, args.roundActionsWidth);
  const gaps = (leading > 0 ? AI_HEADER_GAP_PX : 0) + AI_HEADER_GAP_PX;
  const right = tabs + (tabs > 0 ? AI_HEADER_CLUSTER_GAP_PX : 0) + actions;
  const titleSpace = args.headerWidth - leading - right - gaps;
  return titleSpace < minTitle;
}
